// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__KH2k1","fixPaymentLink":"styles_fixPaymentLink__qQUnw"};